// extracted by mini-css-extract-plugin
module.exports = {"icon-color":"common-availability-keys-icons_icon-color__ftsat"};